import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { BsExclamationCircleFill } from 'react-icons/bs';
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { loadModules } from 'esri-loader';


const ROADS_NPM_KPI = ({ data, changeValues, showModalCal, filter, showModalCalNoise }) => {

    const { setValues, values, sumTotal, formatNumber, calculoPromedio, calculoPer100km, calculoTTI, calculoTTIBased, calculoAveTravel, calculoTrafficRoadNPM } = useKPIs();

    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)


    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        getRegionalPartnerGeo();
    }, [filter.objectid]);

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        let len = data.length;

        const datas = {
            infrastructure: {
                heavyPreiodicMainReq: {
                    req_rehab_open_roads: calculoPromedio('req_rehab_open_roads', filter.yearInit),
                    req_rehab_tunnels: calculoPromedio('req_rehab_tunnels', filter.yearInit),
                    req_rehab_bridges: calculoPromedio('req_rehab_bridges', filter.yearInit),
                    req_hp_maint_open_roads: calculoPromedio('req_hp_maint_open_roads', filter.yearInit),
                    req_hp_maint_tunnels: calculoPromedio('req_hp_maint_tunnels', filter.yearInit),
                    req_hp_maint_bridges: calculoPromedio('req_hp_maint_bridges', filter.yearInit)
                },
                upgratingReq: {
                    req_upgrade_open_roads: calculoPromedio('req_upgrade_open_roads', filter.yearInit),
                    req_upgrade_tunnels: calculoPromedio('req_upgrade_tunnels', filter.yearInit),
                    req_upgrade_bridges: calculoPromedio('req_upgrade_bridges', filter.yearInit)
                },
                climateChangeResil: {
                    ch_flood_inci: calculoPer100km('ch_flood_inci', filter.yearInit),
                    ch_closure_adv_weather_cond: calculoPer100km('ch_closure_adv_weather_cond', filter.yearInit),
                    ch_embank_fail: calculoPer100km('ch_embank_fail', filter.yearInit),
                }
            },
            operations: {
                HVGTTI: calculoTTI('ave_travel_time_hvgs', filter.yearInit),
                PCsTTI: calculoTTI('ave_travel_time_pcs', filter.yearInit),
                delaysBasedTTIHVG: calculoTTIBased('ave_travel_time_hvgs', filter.yearInit),
                delaysBasedTTIPCs: calculoTTIBased('ave_travel_time_pcs', filter.yearInit),
                delaysCost: "",
                ave_travel_time_pcs: calculoAveTravel('ave_travel_time_pcs', filter.yearInit),
                ave_travel_time_hvgs: calculoAveTravel('ave_travel_time_hvgs', filter.yearInit)
            },
            safety: {
                total_traffic_ser_inj: calculoTrafficRoadNPM('total_traffic_ser_inj', filter.yearInit),
                fata_traffic_crash: calculoTrafficRoadNPM('fata_traffic_crash', filter.yearInit),
                ser_inj: ""
            },
            maintenance: {
                maint_cost_total: formatNumber(sumTotal('maint_cost_total', filter.yearInit)),
                maint_cost_open_roads: formatNumber(sumTotal('maint_cost_open_roads', filter.yearInit)),
                maint_cost_tunnels: formatNumber(sumTotal('maint_cost_tunnels', filter.yearInit)),
                maint_cost_bridges: formatNumber(sumTotal('maint_cost_bridges', filter.yearInit)),
                hp_maint_cost: formatNumber(sumTotal('hp_maint_cost', filter.yearInit)),
                emer_maint_cost: formatNumber(sumTotal('emer_maint_cost', filter.yearInit)),
                winter_maint_cost: formatNumber(sumTotal('winter_maint_cost', filter.yearInit)),
                routine_maint_cost: formatNumber(sumTotal('routine_maint_cost', filter.yearInit))
            },
            environmentalImpact: {
                globalWarmingPotential: calculoGlobalW(),
                noise: "" //TODO: CONSULTAR FILTRO
            }
        }

        changeValues(datas)
    }

    const calculoGlobalW = () => {

        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == filter.yearInit);

        dataFiltered.map(item => {
            if (item.attributes.passenger_cars_aadt != null) {
                totalInci += (((item.attributes.length_total_dir_a + item.attributes.length_total_dir_b) * 365 * ((item.attributes.passenger_cars_aadt * 180) + (item.attributes.busses_aadt * 783) + (item.attributes.trucks_aadt * 604))) / 100) / 1000000
            }

        })

        return formatNumber(totalInci / dataFiltered.length);
    }

    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/16";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_road_id=${filter.objectid}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
                setStatusTabDisabled(false);
            } else {
                console.log("No features found with the given npmRoadId");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };


    const generateFormFields = (formValues, typeForm) => {
        const excludedFields = ["objectid", "globalid", "npm_road_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={true}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                </Col>
            ));
    };


    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Heavy/Periodic Maintenance Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_rehab_open_roads" label="Percentage of network requiring rehabilitation (Open Road)" name="infrastructure.heavyPreiodicMainReq.req_rehab_open_roads" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_rehab_tunnels" label="Percentage of network requiring rehabilitation (Tunnels)" name="infrastructure.heavyPreiodicMainReq.req_rehab_tunnels" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_rehab_bridges" label="Percentage of network requiring rehabilitation (Bridges)" name="infrastructure.heavyPreiodicMainReq.req_rehab_bridges" disabled={true} />
                                </Col>

                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_hp_maint_open_roads" label="Percentage of network requiring heavy/periodic maintenance (Open Road)" name="infrastructure.heavyPreiodicMainReq.req_hp_maint_open_roads" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_hp_maint_tunnels" label="Percentage of network requiring heavy/periodic maintenance (tunnels)" name="infrastructure.heavyPreiodicMainReq.req_hp_maint_tunnels" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_hp_maint_bridges" label="Percentage of network requiring rehabilitation (Bridges)" name="infrastructure.heavyPreiodicMainReq.req_hp_maint_bridges" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Upgrading Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.req_upgrade_open_roads" label="Percentage of network requiring upgrade to increase capacity (Open Road)" name="infrastructure.upgratingReq.req_upgrade_open_roads" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.req_upgrade_tunnels" label="Percentage of Network requiring upgrade to increase capacity (Tunnels)" name="infrastructure.upgratingReq.req_upgrade_tunnels" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.req_upgrade_bridges" label="Percentage of network requiring upgrade to increase capacity" name="infrastructure.upgratingReq.req_upgrade_bridges" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Climate Change Resilience</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_flood_inci" label="Number of flooding incidents per 100km" name="infrastructure.climateChangeResil.ch_flood_inci" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" label="Number of closures due to adverse weather conditions per 100km" name="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_embank_fail" label="Number of embankment failures per 100km" name="infrastructure.climateChangeResil.ch_embank_fail" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Operations" title="Operations" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.HVGTTI" label="Travel Time Index (TTI) - Heavy Goods Vehicles" name="operations.HVGTTI" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.PCsTTI" label="Travel Time Index (TTI) - Passenger Cars" name="operations.PCsTTI" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.delaysBasedTTIHVG" label="Delays based on TTI - Heavy Goods Vehicles (minutes)" name="operations.delaysBasedTTIHVG" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.delaysBasedTTIPCs" label="Delays based on TTI – Passenger Cars (minutes)" name="operations.delaysBasedTTIPCs" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.delaysCost" label="Delays Cost (Euro)" name="operations.delaysCost" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.ave_travel_time_pcs" label="Average Travel Time per km – Passenger Cars (minutes)" name="operations.ave_travel_time_pcs" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.ave_travel_time_hvgs" label="Average Travel Time per km – Passenger Cars (minutes)" name="operations.ave_travel_time_hvgs" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Safety" title="Safety" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="safety.total_traffic_ser_inj" label="Road traffic crashes with serious injuries only (no. per million vehicle kilometres)" name="safety.total_traffic_ser_inj" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="safety.fata_traffic_crash" label="Fatal road traffic crashes (no. per million vehicles kilometres)" name="safety.fata_traffic_crash" disabled={true} />
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="safety.ser_inj" label="Seriously Injured (% change relatively to user-defined period)" name="safety.ser_inj" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCal('safety.ser_inj', 'ser_inj')}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Maintenance" title="Maintenance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_total" label="Maintenance cost – total (Euro/km)" name="maintenance.maint_cost_total" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_open_roads" label="Maintenance cost – open road (Euro/km)" name="maintenance.maint_cost_open_roads" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_tunnels" label="Maintenance cost – tunnels (Euro/km)" name="maintenance.maint_cost_tunnels" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_bridges" label="Maintenance cost – bridges (Euro/km)" name="maintenance.maint_cost_bridges" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.hp_maint_cost" label="Heavy/Periodic maintenance cost (Euro/km)" name="maintenance.hp_maint_cost" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.emer_maint_cost" label="Emergency maintenance cost (Euro/km)" name="maintenance.emer_maint_cost" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.winter_maint_cost" label="Winter maintenance cost (Euro/km)" name="maintenance.winter_maint_cost" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.routine_maint_cost" label="Routine maintenance cost (Euro/km)" name="maintenance.routine_maint_cost" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Environmental" title="Environmental Impact" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.globalWarmingPotential" label="Global Warming Potential (CO2 equivalent per year per 100km)" name="environmentalImpact.globalWarmingPotential" disabled={true} />
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmentalImpact.noise" label="Noise (% of network km over user-defined limit)" name="environmentalImpact.noise" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalNoise("environmentalImpact.noise", "noise")}>
                                <button className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}

                                >

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Range</span>
                                    </div>
                                    <BsArrowClockwise className="icon" />
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Others" title="Others" className={style.tabHeight}>
                    <Container>
                        <Row>
                            {generateFormFields(attributes)}
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default ROADS_NPM_KPI;